<template>
    <div id="propertyDetail">
        <!-- <div class="titlee">
            <div>{{propertyDetail.property.name}} | {{propertyDetail.property.sex==1?'男':'女'}} | {{propertyDetail.property.phone}}</div>
        </div> -->
        <van-tabs v-model="active" class="tabs">
            <van-tab title="基本信息">
                <van-cell title="姓名" :value="(propertyDetail.property.name||'-')" />
                <van-cell title="性别" :value="propertyDetail.property.sex===1?'男':propertyDetail.property.sex===0?'女':'-'" />
                <van-cell title="电话" class="space_bet" >
                      <template #right-icon>
                        <a  class="tel" :href="'tel:'+propertyDetail.property.phone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                    
                    </template>
                </van-cell>
                <van-cell title="证件类型" :value="(idTypeList[propertyDetail.property.idType-1]||'-')" />
                <!-- <van-cell title="证件号码" :value="(propertyDetail.property.idNo||'-')" /> -->
                <van-cell title="电子邮箱" :value="(propertyDetail.property.email||'-')" />
                <van-cell title="紧急联系人姓名" :value="(propertyDetail.property.contactName||'-')" />
                <van-cell title="紧急联系人关系" :value="(contactList[propertyDetail.property.contactRelation-1]||'-')" />
                <van-cell title="紧急联系人电话" class="space_bet" >
                    <template #right-icon>
                        <a  class="tel" :href="'tel:'+propertyDetail.property.contactPhone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                    
                    </template>
                </van-cell>
                <van-cell title="地址" :value="propertyDetail.property.address||''" />
                <van-cell title="创建人" :value="propertyDetail.property.creator||'-'" />
                <van-cell title="创建时间" :value="propertyDetail.property.createDate||'-'" />
                <van-cell title="修改人" :value="propertyDetail.property.modifier||'-'" />
                <van-cell title="修改时间" :value="propertyDetail.property.updateDate||'-'" />
                <van-cell title="备注" :value="propertyDetail.property.remark||'-'" />
            </van-tab>
            <van-tab title="房源信息">
                <div class="body" v-if="propertyDetail.houseList.length">
                    <div class="card" v-for="(item,index) in propertyDetail.houseList" :key="index">
                        <p>
                            <span class="title">
                                <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.address}}{{item.rentType == 1?item.roomNo:""}}</span>
                            </span>
                        </p>
                        <p>
                            <span>编码：{{item.number}}</span>
                            <span class="theme-color">{{houseStatusList[item.status-1]}}</span>
                        </p>
                        <p>
                            <span>面积：{{item.totalAcreage}}㎡</span>
                        </p>
                        <!-- <p>
                            <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                            <span class="big">{{item.rental}}元/月</span>
                        </p> -->
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab title="收房合约">
                <div class="body" v-if="propertyDetail.propertyContractList.length">
                    <div class="card" v-for="(item,index) in propertyDetail.propertyContractList" :key="index" @click="$router.push({path:'/fssContractDetail',query:{id:item.id}})">
                        <p>
                            <span class="title">
                                <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.houseAddress}}</span>
                            </span>
                        </p>
                        <p>
                            <span>编码：{{item.number||'-'}}</span>
                            <span class="theme-color">{{pContractStatusList[item.status-1]}}</span>
                        </p>
                        <p>
                            <span>房源编码：{{item.houseNumber||'-'}}</span>
                        </p>
                        <p>
                            <span>租期：{{item.startDate?item.startDate.slice(0,10):'-'}} 到 {{item.endDate?item.endDate.slice(0,10):'-'}}</span>
                        </p>
                        <p>
                            <span>退房日期：{{item.quitDate||'-'}}</span>
                        </p>
                        <p>
                            <span>公司名称：{{item.companyName||'-'}}</span>
                        </p>
                        <!-- <p>
                            <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                            <span class="big">{{item.rental}}元/月</span>
                        </p> -->
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab title="收款信息">
                <div class="body" v-if="propertyDetail.propertyReceiptList.length">
                    <div class="card" v-for="(item,index) in propertyDetail.propertyReceiptList" :key="index">
                        <p>
                            <span class="title">
                                <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{payTypeList[item.payType-1]}}</span>
                            </span>
                        </p>
                        <p>
                            <span>收款人姓名：{{item.accountName||'-'}}</span>
                        </p>
                        <p>
                            <span>收款账号：{{item.bankAccount||'-'}}</span>
                        </p>
                        <p>
                            <span>开户行：{{item.bankName||'-'}}</span>
                        </p>
                        <p>
                            <span>支行名称：{{item.bankBranchName||'-'}}</span>
                        </p>
                        <!-- <p>
                            <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                            <span class="big">{{item.amount }}元</span>
                        </p> -->
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
        </van-tabs>
        <div style="height:1.2rem;"></div>
        <div class="btn">
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_propertyEnable')>-1" class="font3" type="primary" :loading="enbaleLoad" :disabled="enbaleLoad" @click="propertyEnable">{{propertyDetail.property.enable?'禁用':'启用'}}</van-button>
            <a class="font4" :href="'tel:'+propertyDetail.property.phone">
                <van-button type="primary">拨打电话</van-button>
            </a>
            <van-button v-if="$store.state.buttonAuth.indexOf('crm_propertyChange')>-1&&!propertyDetail.property.enable" class="font3" type="primary" @click="$router.push({path:'propertyAdd',query:{id:propertyDetail.property.id}})">修改</van-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestPropertyDetail, requestOwnerEnable } from "@/api";
import {} from "@/utils";
export default {
    name: "propertyDetail",
    data() {
        return {
            active: 0,
            propertyDetail: {
                property: {},
                communityContractList: [],
                houseList: [],
                propertyAssetsList: [],
                propertyContractList: [],
                propertyReceiptList: []
            },
            enbaleLoad: false
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "houseStatusList",
            "payList",
            "contactList",
            "pContractStatusList",
            "payTypeList"
        ])
    },
    created() {
        this.getDetail();
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestPropertyDetail(this.$route.query.id)
                .then(res => {
                    (res.data.houseList || []).forEach(d => {
                        d.showTitle = false;
                    });
                    (res.data.propertyContractList || []).forEach(d => {
                        d.showTitle = false;
                    });
                    this.propertyDetail = res.data;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        propertyEnable() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestOwnerEnable(
                this.propertyDetail.property.id,
                !this.propertyDetail.property.enable / 1
            )
                .then(res => {
                    toast1.clear();
                    this.getDetail();
                })
                .catch(err => {
                    toast1.clear();
                    console.log(err);
                });
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#propertyDetail {
    .colorC {
        color: $colorC;
    }
    .fail-color {
        color: $fail-color;
    }
    .theme-color {
        color: $theme-color;
    }
    .titlee {
        padding: 0.2rem 0.42667rem;
        background-color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: space-between;
        position: relative;
        &::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 0;
            border-bottom: 0.02667rem solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
    }
    .clock {
        i {
            vertical-align: middle;
        }
    }
    .content {
        background-color: #fff;
        display: flex;
        // border-radius: 0.2rem;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        &.nowarp {
            flex-wrap: nowrap;
        }
        .inlineB {
            flex: 1;
            padding: 0.2rem 0;
            width: 33.3%;
            min-width: 33.3%;
            max-width: 33.3%;
            position: relative;
            p.l {
                line-height: 0.7rem;
                height: 0.7rem;
            }
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
    .tabs {
        /deep/.van-tabs__wrap {
            margin: 0 0 0.2rem 0;
        }
        /deep/.van-tabs__content {
            height: calc(100vh - 2.6rem);
            overflow: scroll;
        }
        .van-steps {
            text-align: left;
            padding-left: 2rem;
            /deep/.van-step__title {
                padding-left: 0.3rem;
                p {
                    padding-top: 0.2rem;
                }
            }
        }
        .body {
            // padding-top: 0.001rem;
            font-size: 0.35rem;
            // margin-top: 0.3rem;
            .card {
                background: #fff;
                margin: 0.3rem;
                border-radius: 0.2rem;
                color: $color9;
                padding: 0.2rem 0;
                // margin: 0.2rem 0;
                p {
                    text-align: left;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 0.4rem;
                    line-height: 0.8rem;
                    // height: 0.8rem;
                    .title {
                        font-size: 0.35rem;
                        font-weight: 600;
                        height: auto;
                        color: #000;
                        // span {
                        //     max-width: 4.5rem;
                        //     vertical-align: top;
                        //     overflow: hidden;
                        //     display: inline-block;
                        //     height: auto;
                        //     text-overflow: ellipsis;
                        // }
                        // .ellipsis {
                        //     white-space: nowrap;
                        // }
                    }
                    .big {
                        font-size: 0.4rem;
                    }
                }
            }
            > .card:first-child {
                margin-top: 0;
            }
            .theme-color {
                color: $theme-color;
            }
        }
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
        a {
            color: #fff;
            flex: 1;
            button {
                width: 100%;
            }
            position: relative;
            &::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
        .font4 {
            width: 2.7rem;
        }
        .font3 {
            width: 1.8rem;
        }
        // .font5 {
        //   width: 51%;
        // }
        .font1 {
            width: 100%;
            margin-left: 0;
        }
    }
}
</style>
